module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAARBAMAAADAqPqzAAAAAXNSR0IB2cksfwAAACdQTFRFAAAAKHr/KXn/Knj/KXn/KXn/KHj/KXn/Knr/KXn/KHn/KXn/KXn/abIv8QAAAA10Uk5TAGDvn/9wQPAwz9BQoJsa7KQAAABKSURBVHicY2BgYGBUZoADEZcAGJPRxSUBIeyIEHZHEq5AEm5ACMPABAY408UBSXwBUL0TXD1QQoMBYRCKhDaSBMI9yO5kYKyB0ACh+xM+HF6m3QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/images/back.png
// module id = 167
// module chunks = 0